import { atom } from 'jotai';
import { UploadTask_Base } from '~/common/typescript/models/UploadTask';

export const uploadTasksAtom = atom<UploadTask_Base[]>([]);

export const uploadTaskListRefreshTrigger = atom<number>(0);

export const activeUploadTasksCountAtom = atom<number>(0);

export const isTaskProcessingAtom = atom<boolean>((get) => get(activeUploadTasksCountAtom) > 0);
